import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateShort = normalize(function (_ref) {
  var _window, _window$navigator;

  var success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;

  if (!((_window = window) != null && (_window$navigator = _window.navigator) != null && _window$navigator.vibrate)) {
    fail && fail('@uni：vibrateShort 当前环境暂不支持');
    complete && complete('@uni：vibrateShort 当前环境暂不支持');
    return;
  }

  var res = window.navigator.vibrate(15);

  if (res) {
    success && success();
    complete && complete();
  } else {
    fail && fail();
    complete && complete();
  }
}, CONTAINER_NAME.WEB);
export default vibrateShort;